<!--
 * @description: 联系我们
 * @Author: Jay
 * @Date: 2021-09-24 12:02:26
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-19 15:54:00
-->
<template>
  <div>
    <!-- 顶部Tab 切换 -->
    <TopTab></TopTab>
    <!-- 页面内容 -->
    <div class="us-lad" v-if="usData != ''">
      <!-- 顶部 背景 标题 -->
      <bg-img-top
        :bgImg="$api + usData.image"
        EnTitle="Contact Us"
        title="联系我们"
      ></bg-img-top>
      <!-- 公司信息 -->
      <div class="lad-code">
        <firm-info-code :infoData="usData"></firm-info-code>
      </div>
    </div>
    <!-- 底部边距 -->
    <div class="height-al"></div>
    <!-- 底部信息 -->
    <root-bottom></root-bottom>
  </div>
</template>

<script>
// 顶部Tab 切换
import TopTab from "@/components/tab/top-tab.vue";
// 底部信息
import rootBottom from "@/components/bottom/root-bottom.vue";
// 顶部 背景 标题
import bgImgTop from "@/components/tab/bg-img-top.vue";
// 公司信息
import firmInfoCode from "../../components/code/firm-info-cod.vue";
import { contactus } from "../../api/api";

export default {
  name: "ContactUS",
  data() {
    return {
      usData: [],
    };
  },
  components: {
    TopTab,
    rootBottom,
    bgImgTop,
    firmInfoCode,
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      //联系我们
      contactus().then((res) => {
        // console.log(res);
        this.usData = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.us-lad {
  position: relative;
}
// 公司信息 定位
.lad-code {
  position: absolute;
  left: 18%;
  z-index: 11;
  bottom: -200px;
  // background-color: red;
}
</style>